/** Shared expand / collapse animation timings (ms). */

/**
 * Hold before background hexes start — matches HexTile width/position
 * transition so sibling reflow is almost finished.
 */
export const PUSH_HOLD_MS = 280

/** Sibling width/left reflow duration (HexTile CSS transition). */
export const REFLOW_MS = 340

/**
 * Close crossfade: expanded chrome out + layered hex in, same duration.
 * Runs with the layout frozen so nothing moves until the fade completes.
 * Kept generous so the expanded view visibly fades before the gap closes.
 */
export const CLOSE_FADE_MS = 440

/**
 * Gap-close reflow (after the crossfade): slower than the open push so the
 * collapse reads as its own smooth motion and blends with the open timing.
 */
export const CLOSE_REFLOW_MS = 460

/** Single background hex fade+scale duration — also the collapsed fade-out duration. */
export const BG_DURATION_MS = 320
/** Delay between successive background hexes. */
export const BG_STAGGER_MS = 55
/** 5 bg hexes: last starts at 4 * stagger. */
export const BG_WAVE_MS = BG_DURATION_MS + BG_STAGGER_MS * 4

/** Inner (detail) hexes start when the bg wave is ~80% complete (from bg start). */
export const INNER_START_MS = Math.round(BG_WAVE_MS * 0.8)
export const INNER_DURATION_MS = 340
export const INNER_STAGGER_MS = 40
export const INNER_OVERSHOOT = 1.1

/** Text after the first inner pulse roughly settles. */
export const TEXT_START_MS = INNER_START_MS + Math.round(INNER_DURATION_MS * 0.75)
export const TEXT_DURATION_MS = 220

/** Arrow after text. */
export const ARROW_START_MS = TEXT_START_MS + TEXT_DURATION_MS
export const ARROW_DURATION_MS = 260

/** Absolute from expand open (includes push hold). */
export const OPEN_AT_MS = PUSH_HOLD_MS + ARROW_START_MS + ARROW_DURATION_MS

export const EXPAND_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)'
export const EXPAND_EASE_PULSE = 'cubic-bezier(0.34, 1.45, 0.64, 1)'
/** Soft crossfade / reflow easing for close. */
export const CLOSE_EASE = 'cubic-bezier(0.4, 0, 0.2, 1)'
